import { FC, memo, useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox, useBreakpoint, useToasts } from '@brg/ui';
import { useProfile, bProfile } from '@brg/auth';
import { BookmarkAPI, Project, ProjectAPI, API, Endpoints, Card, Team, TeamAPI, Competition } from '@brg/api';
import { LayoutConst } from 'core/modules';

import { ProjectDesignerName } from '../projectDesignerName';
import { LikesBox } from '../likesBox';
import {ProjectCardSubTitle, ProjectCardTitle} from './styles';
import { ProjectCardTools } from './ProjectCardTools';
import { createCopyLinkProjectFn } from '../../helpers/copyLink';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import ProjectCardLayoutNew from './projectCardLayoutNew';
import { ProjectDelegate } from "../../../project-delegate";
import { useModal } from '../../../core'
import { IProjectLight } from "../../common";
import { ProjectEvents } from "../../helpers/projectEvents";
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { getProjectImages } from "../../pages/project/sections/ps-image";
import { useTranslation } from "react-i18next";
import { isProjectRepostedOnShowcase, isRejectedFromCompetition, ProjectOnDisplay } from "../../helpers/projectStatus";
import { SOUND_ART_TAG_ID } from "../../constants/misc";
import { AppTester } from 'supporting';
import { PointBox } from '../pointBox/PointBox';
import { AlertBlock } from 'shared/icons/AlertBlock';
import CheckSmallIcon from 'shared/icons/CheckSmallIcon';
import { DeleteButton } from '../DeleteButton/DeleteButton';
import { BookmarkButton } from '../bookmarkButtonOnProject/BookmarkButton';
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/constants';
import { useGetShowcaseContext } from 'shared/hooks/useGetShowcaseContext';
import { RingPositions } from 'shared/constants/ringPositionType';
import {BookDelegate} from "../../../_deziiign/books/core/book-delegate";
import {getPresentationImages} from "../../helpers/utils/getPresentationImages";
import { isTeamTabProjectWideCover } from 'shared/modals/teamTabProjectsOrder/teamTabProjectCoverLayout';
import { isExpert, isExpertByPolicy } from 'shared/helpers/utils/TagsUtils';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { ProfileRole } from 'core/utils/bProfile';
import { extractIds } from 'shared/constants/extractIds';
import { useFoldersController } from 'shared/hooks/useFoldersController';
import { useDispatch, useSelector } from 'react-redux';
import ProfileFoldersSlice, { ProfileFoldersSelector } from 'shared/reducers/ProfileFoldersSlice';
import urlApi from 'shared/actions/urlApi';
import { executeTypografValue } from 'shared/utils/executeTypograf';
import { Placement } from '../tooltips';
import RepostButton from '../repostButton/repostButton';
import { HiddenContentText } from './components/HiddenContentText';
import { useProjectCardPermissions } from './hooks/useProjectCardPermissions';
import { useDeleteLMSModule } from 'shared/hooks/api/LMS/useDeleteLMSModule';
import { DesignerTab } from 'shared/constants/designerTab';
import { useProjectCardCompetition } from './hooks/useProjectCardCompetition';
import { useProjectCardBookmark } from './hooks/useProjectCardBookmark';
import { ProjectBadge } from '../TeamBadges/ProjectBadge';

/** 
* Показать конкурсные баллы 
* @param showCompetitionPoint 
*/

export const ExportCheckbox = styled.div<{ checked?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 34px;
  border: 2px solid #fefefe;
  background: ${({ checked }) => checked ? 'rgba(254, 254, 254, 1)' : 'rgba(24, 26, 28, 0.5)'};
  backdrop-filter: blur(2px);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;

  &::after {
    content: '';
    display: ${({ checked }) => checked ? 'block' : 'none'};
    width: 7px;
    height: 12px;
    border: 2px solid #151514;
    border-top: none;
    border-left: none;
    transform: rotate(45deg) translate(-1px, -1px);
  }
`;

export const SelectRing = styled(FlexBox)<{ active?: boolean, ringPosition?: RingPositions, disable?: boolean, incIdx?: boolean }>`
  background: rgba(24, 26, 28, 0.5);
  border: 2px solid #fefefe;
  backdrop-filter: blur(2px);
  box-sizing: border-box;

  ${({ incIdx }) => incIdx && css`
    z-index: 1;
  `};
  border-radius: 34px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: white;

  ${({ disable }) => disable && css`
    pointer-events: none;
  `}

  ${({ ringPosition }) => ringPosition ? css`
    margin: ${ringPosition === RingPositions.left ? '0 auto 0 0' : '0 0 0 auto'};
  ` : null};

  svg {
    outline: none !important;
  }

  ${p => p.active ? css`
    background: rgba(254, 254, 254, 1);
    border: 2px rgba(254, 254, 254, 1);
    box-sizing: border-box;
    border-radius: 34px;
  ` : null}
`;

export const Author = styled(FInter.SmallText)<{ hasBottomText?: boolean }>`
  @media (max-width: 940px) {
    div {
      font-weight: 400;
    }
  }

  ${({ hasBottomText }) => !hasBottomText && css`
    color: ${Colors.geoWhite100};
  `}
`

export interface ProjectCardDisplayProps {
  isLoading?: boolean;
  isOneColumn?: boolean;
  width?: string;
  height?: string;
  sizeMult?: number;
  rank?: number;
  metaAlwaysVisible?: boolean;
  isMobileMoreVisible?: boolean;
  projectType?: string;
  itemType?: string;
}

export interface ProjectCardSelectionProps {
  isSelectable?: boolean;
  isUnselectable?: boolean;
  selected?: boolean;
  isSelectRightNeed?: boolean;
  selectRingPosition?: RingPositions;
  alreadyProject?: boolean;
  editingProject?: boolean;
  onSelect?: (projectId: string) => void;
  onSelectProject?: (project: Project | undefined) => void;
}

export interface ProjectCardCompetitionProps {
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  isParticipant?: boolean;
  competition?: Competition<'Local'>;
}

export interface ProjectCardPermissionProps {
  isEditable?: boolean;
  isDeletable?: boolean;
  isCanNotParticipate?: boolean;
  isCanNotBeDraft?: boolean;
  isCanNotBeBookmark?: boolean;
  canMakeImageForTeam?: TOwnerRights;
}

export interface ProjectCardNavigationProps {
  linkPrefix?: string;
  linkTo?: string;
  linkTarget?: string;
  withoutGoToProject?: boolean;
  openInModal?: boolean;
  useDirectNavigation?: boolean;
  isModal?: boolean;
  onProjectClick?: (projectId?: string, e?: any) => void;
}

export interface ProjectCardContentProps {
  project?: Project;
  isBook?: boolean;
  card?: Card;
  channel?: Team<'Global'>;
  isChannel?: boolean;
  entityType?: string;
  isRejected?: boolean;
  isRemovableFromBook?: boolean;
  isCert?: boolean;
}

export interface ProjectCardEventHandlers {
  onShouldReload?: (sender: any) => void;
  onRemoveFromBook?: (projectId: string) => void;
  onApprove?: (projectId: string) => void;
  onReject?: (projectId: string) => void;
  onUpdate?: () => void;
}

export interface ProjectCardNewProps extends 
  Partial<IProjectLight>, 
  ProjectEvents,
  ProjectCardDisplayProps,
  ProjectCardSelectionProps,
  ProjectCardCompetitionProps,
  ProjectCardPermissionProps,
  ProjectCardNavigationProps,
  ProjectCardContentProps,
  ProjectCardEventHandlers {
  tooltip?: ProjectTooltipProps;
  placement?: Placement;
  isCard?: boolean;
  withoutRepost?: boolean;
  dataKey?: any;
  showAnnotations?: boolean;
  isSortedByNotModerated?: boolean;
  isExport?: boolean;
  isMobile?: boolean;
  isOuterOrganizationShowcase?: boolean;
  isHeadCommentsVisibleLocal?: boolean;
  hideBelowCoverTitleAndAuthor?: boolean;
  activeTabKey?: string;
}

const ProjectCardNew: FC<ProjectCardNewProps> = (props) => {
    const {
      isLoading,
      isSelectable,
      isUnselectable,
      isDeletable,
      isOneColumn,
      isRemovableFromBook,
      image,
      identifier,
      // channel,
      isChannel,
      entityType,
      title,
      likes,
      authors,
      author,
      coAuthors,
      isLiked,
      isEditable,
      isRejected,
      tooltip,
      width,
      height,
      selected,
      rank,
      isParticipant,
      useDirectNavigation,
      metaAlwaysVisible,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      isMobileMoreVisible,
      currentCompetitionId,
      withoutRepost,
      openInModal,
      onApprove,
      onReject,
      onSelect,
      onShouldReload,
      onProjectClick,
      onRemoveFromBook,
      isModal,
      project,
      placement,
      isBook,
      alreadyProject,
      editingProject,
      linkPrefix,
      isSelectRightNeed,
      selectRingPosition,
      sizeMult,
      withoutGoToProject,
      isCanNotParticipate,
      canMakeImageForTeam,
      projectType,
      isCanNotBeDraft,
      isCanNotBeBookmark,
      isCard,
      itemType,
      onUpdate,
      onSelectProject,
      isCert,
      card,
      linkTo,
      linkTarget,
      competition,
      showAnnotations,
      isSortedByNotModerated,
      isExport,
      isMobile: isMobileProp,
      isHeadCommentsVisibleLocal,
      isOuterOrganizationShowcase,
      hideBelowCoverTitleAndAuthor,
      activeTabKey,
      ...handlers
    } = props;

    const history = useHistory();
    const profile = useProfile();
    const toasts = useToasts();
    const modal = useModal();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const isAgeyTomesh = AppTester.isAgeytomesh();
    const isOnlines = AppTester.isOnlines();
    const isMedia = AppTester.isMediiia();
    const isCompetitionProjectsPage = !!useRouteMatch('/competition/:id');
    const { id } = useParams<{ id: string }>();
    const [isReposted, setIsReposted] = useState<boolean>(false);
    const [pointVisible, setPoinVisible] = useState<boolean | null>(null);
    const [ showcaseContext ] = useGetShowcaseContext();
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);
    const isTab = useBreakpoint(LayoutConst.screen.m);

    const { foldersList } = useSelector(ProfileFoldersSelector);
    const { onRemoveProject } = useFoldersController();
    const { deleteModule: deleteLMSModule } = useDeleteLMSModule();

    const isLMSDraftsTab = activeTabKey === DesignerTab.lmsDrafts;

    const handleDeleteLMSModule = useCallback((projectId: string) => {
      modal.show('template-modal', {
        mainText: t('lms.delete_module.title'),
        secondText: t('lms.delete_module.description'),
        confirmText: t('lms.delete_module.confirm'),
        cancelText: t('lms.delete_module.cancel'),
        onConfirm: async () => {
          const ok = await deleteLMSModule(projectId);
          if (ok) {
            toasts.info(t('lms.delete_module.success'));
            onUpdate?.();
            onShouldReload?.(projectId);
            modal.hide();
          } else {
            toasts.error(t('lms.delete_module.error'));
          }
        },
        onSecond: () => modal.hide(),
      });
    }, [modal, t, toasts, deleteLMSModule, onUpdate, onShouldReload]);

    const isBanned = useMemo(() => project?.status === 3, [project])

    const isProjectFromCard = useMemo(() => {
      return project?.projectType === 'fixed-ratio-small' && project?.isAdaptiveCard
    }, [project])

    // @ts-ignore
    const hasBottomText = useMemo(() => {
      if (isProjectFromCard) {
        return false
      }
      return project?.projectType === 'fixed-ratio-large'
    }, [project]);

    const calcProjectType = useMemo(() => {
      //@ts-ignore
      const baseType = project?.projectType || projectType
      if (project && isOuterOrganizationShowcase && isTeamTabProjectWideCover(project)) {
        return 't-shape'
      }
      return baseType
    } , [project, projectType, isOuterOrganizationShowcase])

    const presentationImages = getPresentationImages(project);

    const handlePointViewToggle = (flag: boolean) => {
      setPoinVisible(flag)
    }

    const handleToolTipToggleMove = useCallback((val: boolean) => {
      setTooltipOpen?.(val);
    } , [])

    const onProjectClickDefault = useCallback((projectId?: string, ev?: any): void => {
      if (!projectId || !ev) {
        return;
      }

      // disable navigation for bookmark btn
      if (ev.target.tagName === "rect" || ev.target.tagName === "svg" || ev.target.tagName === "path" || (ev.target.tagName === "DIV" && ev.target.className.includes("BookmarkButtonWrapper"))) {
        ev.preventDefault()
      }

      if (openInModal) {
        modal.show('project', { projectId });
      }

    }, [modal, openInModal]);

    const onDesignerSelected = useCallback(
      (designerId: string): void => history.push(CreateLinkTo.designer(designerId)),
      [history]
    );

    const onRemoveFromShowcase = useCallback((projectId: string): void => {
      
      if (!showcaseContext || showcaseContext === '') {
        return;
      }

      if (Array.isArray(showcaseContext)) {
        Promise.all(showcaseContext?.map((i) => (
          API.request()
          .endpoint(Endpoints.geograffee)
          .url(`/api/Project/UpdateContexts`)
          .post()
          .body({
            projectId: projectId,
            contexts: [{
              context: i,
              operation: 0,
            }],
          })
          .send()
        )))
        .then(() => {
          onShouldReload?.(projectId);
          toasts.info(t('toasts.removed_from_showcase', { name: title }));
        });
        return;
      }

      API.request()
      .endpoint(Endpoints.geograffee)
      .url(`/api/Project/UpdateContexts`)
      .post()
      .body({
        projectId: projectId,
        contexts: [{
          context: showcaseContext,
          operation: 0,
        }],
      })
      .send()
      .then(() => {
        onShouldReload?.(projectId);
        toasts.info(t('toasts.removed_from_showcase', { name: title }));
      });
    }, [onShouldReload, title, toasts, t, showcaseContext]);

    const isBookChapter = window.location.pathname.startsWith("/books/book-edit") || (AppTester.isBooksMain() && window.location.pathname.startsWith("/book-edit"));

    const {
      isEditableLocal,
      canBeDraft,
      isMe,
      isCreator,
      canEditFolders,
      isTagModer_Expert,
      isTagModer_ExpertByPolicy,
      hasEditProjectPolicy,
      isMoreVisible: isMoreVisibleFromPermissions,
      canAddBookmark,
      isCanBeRepost,
      isHeadCommentVisible,
    } = useProjectCardPermissions({
      project,
      isEditable,
      isSelectable,
      isCanNotParticipate,
      isCanNotBeDraft,
      isBookChapter,
      isJury: showCompetitionJuryPoint
    });

    const titleImages = useMemo(() => {
      if (getProjectImages(project, i18n.language)?.length > 0) {
        return getProjectImages(project, i18n.language)
      }
      return presentationImages
    } , [project, presentationImages, i18n])
    
    const isProjectOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    const isProjectPartInCompetition = useMemo(() => {
      //@ts-ignore
      if (!project || project.canEdit_PartCompetition) return false;
      if (isRejectedFromCompetition(project, currentCompetitionId)) return false;
      return true;
    }, [project, currentCompetitionId])
    const isProjectTitle = useMemo(() => {
      if (Array.isArray(project?.additionalContent?.title?.text) && project?.additionalContent?.title?.text?.length === 0) {
        return undefined;
      }
      return executeTypografValue(project?.additionalContent?.title?.text)
    }, [project])
    const projectSubTitle = useMemo(() =>
    //@ts-ignore
    executeTypografValue(project?.additionalContent?.subtitle?.text), [project])

    const projectCardTitle = useMemo(() =>
      isProjectTitle || executeTypografValue(title), [isProjectTitle, title])

    const isDefaultCoverVisible = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN) && !project?.titleImages?.length), [project])

    const isSelectedClick = (sel: boolean | undefined) => {
      return sel ? undefined : CreateLinkTo.projectNew(project) 
    }

    const onRemoveFromFolders = async (projectId: string) => {
      if (!foldersList?.length) return;

      const initFolders = async () => {
        const data = await urlApi().fetchFolders(profile?.designerId ?? '')

        if (Array.isArray(data)) {
          dispatch(ProfileFoldersSlice.actions.setFolders(data))
        };
      }

      const tFolder = foldersList?.find((folder) => folder?.entityIds?.includes(projectId))

      if (tFolder) {
        onRemoveProject({...tFolder, entityIds: [projectId]}).then((r) => {
          initFolders();
        })
      }
    }

    const projectIsOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    //@ts-ignore
    const isPresentation = useMemo(() => (project?.isPresentation),[project]);

    const onDraft = useCallback((projectId: string): void => {
      if (isProjectPartInCompetition) {
        toasts.error(t('toasts.project_part_competition'))
        return
      }
      if (handlers?.onMoveDrafts) {
        handlers.onMoveDrafts(projectId)
        return
      }
      const confirmation = window.confirm(t('project.confirmation_msg.to_drafts'));
      if (!confirmation) return;
      ProjectAPI.UpdateStatus({ projectStatus: 0, projectId }).then(() => {
        onRemoveFromFolders(projectId)
        onShouldReload?.(projectId);
        toasts.info(t("toasts.project_move_to_drafts_title", {
          title
        }));
      });
    }, [toasts, onShouldReload, title, isProjectPartInCompetition, handlers, t]);
    
    const { competitionGPA } = useProjectCardCompetition({
      project,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      currentCompetitionId,
      competition,
    });

    const shouldVisibleRemoveFromShowcase = useMemo(() => (
      !AppTester.isDvaDesign() && 
      !AppTester.isGeoMain() &&
      !AppTester.isAcademy() &&
      !AppTester.isDeziiignMain() &&
      !AppTester.isMediiia()
      ), []
    )

    const hidePrivateProject = useMemo(() => {
      return isChannel && !isParticipant && project?.status === 10
    } ,[isChannel, isParticipant, project])

    const backgroundStyles = useMemo(() => {
      if (hidePrivateProject) {
        return {
          background: 'linear-gradient( 180deg,rgba(0, 0, 0, 0),  rgba(24, 26, 28, 0.3), rgba(24, 26, 28, 1) )',
          backdropFilter: 'blur(25px)',
          marginTop: 0
        }
      }
      return undefined
    } , [hidePrivateProject])

    const backgroundText = useMemo(() => {
      if (hidePrivateProject) {
        return <HiddenContentText />
      }
      return undefined
    } , [hidePrivateProject])

    const { isBookmarked, handleBookmarkClick } = useProjectCardBookmark({
      project,
      onUpdate,
    });

    useEffect(() => {
      if (!project) return;
      //@ts-ignore
      setIsReposted(project?.isReposted || false);
    }, [project]);

      const isMoreVisible = isExport ? true : isMoreVisibleFromPermissions;

      const isNominated = useMemo(() => {
        return !!project?.contexts?.includes('nomination')
      }, [project])

      const onNominationClick = useCallback(async () => {
        await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/UpdateContexts`)
        .post()
        .body({
          projectId: project?.projectId,
          contexts: [{
            context: 'nomination',
            operation: !isNominated? 1 : 0
          }],
        })
        .send()
        .then((res) => {
          if (res.status === 200) {
            const infoMsg = !isNominated? 'Проект номинирован на лучший проект месяца' : 'Проект снят с номинации'

            toasts.info(infoMsg);
          }
        }).catch((e) => {
          toasts.info('Ошибка запроса');
        })
      }, [isNominated, toasts, project])

      const tooltipProps = useMemo(() => {
        return {
          tooltipOpen: isTooltipOpen,
          toggleTooltip: handleToolTipToggleMove
        }
      } , [isTooltipOpen, handleToolTipToggleMove])

      const badge = useMemo(() => {
        if (!project) return undefined;
        return <ProjectBadge project={project} />
      } , [project])

      const selectRing = useMemo(() => {
        if (!isSortedByNotModerated) return undefined;
        return (
          <SelectRing className='selectRing' active={selected} ringPosition={RingPositions.left} onClick={(ev) => {
            if (onSelect) {
              ev.stopPropagation();
              ev.preventDefault();
              onSelect(identifier ?? '');
            }
            if (onSelectProject) {
              ev.stopPropagation();
              ev.preventDefault();
              onSelectProject(project);
            }
          }}>
            {selected && (
              <div>
                <CheckSmallIcon />
              </div>
            )}
          </SelectRing>
        );
      }, [identifier, isSortedByNotModerated, onSelect, onSelectProject, project, selected]);

      if (hidePrivateProject) {
        return (
          <ProjectCardLayoutNew
            isMobile={isMobileProp}
            title={''}
            linkTo={''}
            author={undefined}
            onClick={() => null}
            backgroundStyles={backgroundStyles}
            backgroundText={backgroundText}
            isMobileMoreVisible
            img={image}
            project={project}
            titleImages={titleImages}
            width={width}
            height={height}
            identifier={identifier}
            sizeMult={sizeMult}
            withoutGoToProject={true}
            itemType={itemType}
            projectType={calcProjectType}
          />
        )
      }

      
      return (
      <ProjectCardLayoutNew
        isMobile={isMobileProp}
        linkParams={showCompetitionJuryPoint && currentCompetitionId ? `?currentCompetitionId=${currentCompetitionId}` : ''}
        identifier={identifier}
        onClick={onProjectClick ?? onProjectClickDefault}
        img={image}
        badge={badge}
        backgroundStyles={backgroundStyles}
        project={project}
        titleImages={titleImages}
        isLoading={isLoading}
        width={width}
        linkTo={linkTo}
        linkTarget={linkTarget}
        height={height}
        isBook={isBook}
        rank={rank}
        isModal={isModal}
        href={isSelectedClick(selected)}
        hasBottomText={hasBottomText}
        title={<ProjectCardTitle>{projectCardTitle}</ProjectCardTitle>}
        subtitle={projectSubTitle ? <ProjectCardSubTitle>{projectSubTitle}</ProjectCardSubTitle> : undefined}
        isOneColumn={isOneColumn}
        isMoreVisible={isMoreVisible}
        isMobileMoreVisible={isMobileMoreVisible}
        isRejected={isRejected}
        isExport={isExport}
        metaAlwaysVisible={metaAlwaysVisible}
        {...tooltipProps}
        toggleViewPoint={handlePointViewToggle}
        linkPrefix={linkPrefix ? linkPrefix : undefined }
        isSelectRightNeed={isSelectRightNeed}
        sizeMult={sizeMult}
        withoutGoToProject={withoutGoToProject}
        itemType={itemType}
        projectType={calcProjectType}
        showAnnotations={showAnnotations}
        hideBelowCoverTitleAndAuthor={hideBelowCoverTitleAndAuthor}
        isSortedByNotModerated={isSortedByNotModerated}
        selectedComponent={selectRing}
        bookmarkButton={
          //@ts-ignore
          !isCompetitionProjectsPage && !isCard && !isBanned && (!isSelectable && <BookmarkButton type={project?.projectType === 't-shape'} isBookmarked={isBookmarked} onClick={handleBookmarkClick}/>)
        }
        repostButton={
          !isSelectable && !withoutRepost && !isBanned && project && profile && (
            <RepostButton 
              project={project} 
              iconOnPage 
              onUpdate={onShouldReload} 
            />
          )
        }
        more={
          isSortedByNotModerated ? null : (alreadyProject || editingProject) ? (
            <SelectRing active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} {...(isUnselectable && { onClick: (ev) => {
              if (onSelect) {
                ev.stopPropagation();
                ev.preventDefault();
                onSelect(identifier ?? '');
              }
            }})}>
                <div>
                  <CheckSmallIcon
                    fill={selected ? '#151514' : alreadyProject ? '#fff' : '#151514'}
                    stroke={selected ? '#151514' : alreadyProject ? '#fff' : '#151514'}
                  />
                </div>
            </SelectRing>
          ) : isSelectable
            ? (
              <SelectRing className='selectRing' active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} onClick={(ev) => {
                if (onSelect) {
                  ev.stopPropagation();
                  ev.preventDefault();
                  onSelect(identifier ?? '');
                }
                if (onSelectProject) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onSelectProject(project);
                }
              }}>
                {selected && (
                  <div>
                    <CheckSmallIcon />
                  </div>
                )}
              </SelectRing>
            )
            : isCard ? null : isExport ? (
              <ExportCheckbox
                checked={!!selected}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if (onSelect) onSelect(identifier ?? '');
                }}
              />
            ) : (
              <ProjectCardTools
                {...handlers}
                {...tooltipProps}
                placement={placement}
                isHiddenCancel={true}
                canViewStatistic={isTagModer_Expert}
                headCommentVisible={isHeadCommentVisible || isHeadCommentsVisibleLocal}
                isCanBeDraft={!isLMSDraftsTab && canBeDraft && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                identifier={identifier}
                isEditable={!isAgeyTomesh && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                isRemovableFromShowcase={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile) || hasEditProjectPolicy) && isProjectOnDisplay && shouldVisibleRemoveFromShowcase}
                isDeletable={isDeletable}
                {...(isLMSDraftsTab && { isDeletable: true, onDelete: handleDeleteLMSModule })}
                canEditFolders={canEditFolders}
                isCopyLink={true}
                projectType={calcProjectType}
                isInOnDisplay={isProjectOnDisplay}
                isSuperModer={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))}
                //@ts-ignore
                isTagModerator={profile && (profile.tagListId?.some(x => project?.tagsID?.includes(x)) || profile.tagListId_Expert?.some(x => project?.tagsID?.includes(x)))}
                isTagExpert={isTagModer_Expert || isTagModer_ExpertByPolicy}
                isNominated={isNominated}
                onNominationClick={onNominationClick}
                isTeamOwner={canMakeImageForTeam?.canMake}
                onMoveFromShowcase={onRemoveFromShowcase}
                onCopyLink={createCopyLinkProjectFn(toasts, t)}
                onMoveDrafts={onDraft}
                isPresentation={isPresentation}
                toggleTooltip={handleToolTipToggleMove}
                isCoauthor={profile && project?.coAuthorIds?.includes(profile?.accountId)}
                onAddBookmark={handleBookmarkClick}
                onOpenHeadComment={() => {
                  modal.show('head-comment', {
                    project: project,
                    competitionId: currentCompetitionId,
                  })
                }}
                onRejectCoauthor={() => {
                  const confirmation = window.confirm('Вы действительно хотите отказаться от соавторства?');
                  if (confirmation) {
                    API.request()
                        .endpoint(Endpoints.geograffee)
                        .url('/api/Project/RefuseCoAuthorship')
                        .post()
                        .body({
                            projectId: project?.projectId || ''
                        })
                        .release()
                        .then((r: any) => {
                            if (r.status === 400 || r.status === 500) {
                                toasts.error(t('toasts.project_reject_coauthor_error'))
                                return;
                            }
                            toasts.info(t('toasts.project_reject_coauthor'))

                            setTimeout(() => window.location.reload(), 1500)
                        })
                        .catch((e: any) => toasts.error(t('toasts.project_reject_coauthor_error')))
                      }
                }}
                onMakeImageForOrganization={(projectId) => {
                  if (canMakeImageForTeam?.canMake) {
                    const confirmation = window.confirm('Сделать изображение обложкой юнита?');
                    if (confirmation) {
                      API.request()
                      .endpoint(Endpoints.geograffee)
                      .url('/api/Team/CopyTitleFromProject')
                      .post()
                      .body({
                        teamId: canMakeImageForTeam.teamId,
                        projectId
                      })
                      .release()
                      .then((r: Response) => {
                        toasts.info('Успешно');
                      })
                      window.location.reload();
                    }
                  }
                 }} 
                onMakeBilingual={(projectId) => {
                  const confirmation = window.confirm('Вы действительно хотите сделать проект двуязычным?')
                  if (confirmation) {
                    history.push(CreateLinkTo.bilingual(projectId))
                  }
                }}
                onRepost={() => {
                  modal.show('repost-into-channel', {
                    projectId: project?.projectId,
                    // callBack: (flag: boolean) => {
                    //   setIsReposted(flag)
                    // }
                  })
                }}
                  //@ts-ignore
                canMakeBilingual={!project?.isBilingual && !project?.longreadId_en
                && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
                && !(projectIsOnDisplay && !(profile && bProfile.isModer(profile)) && !hasEditProjectPolicy)
                &&  !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                {...(tooltip ?? {})}
                project={project}
                linkPrefix={linkPrefix ? linkPrefix : undefined }
                isCanNotParticipate={isCanNotParticipate}
                isPartInCompetition={isProjectPartInCompetition}
                isBookmarked={isBookmarked}
                canAddBookmark={canAddBookmark}
                isCanBeRepost={isCanBeRepost}
              />
            )
        }
        author={
          !isOnlines && (
            <Author hasBottomText={hasBottomText} >
            <ProjectDesignerName
              value={author ? [author].concat(coAuthors ?? []) : (coAuthors ?? [])}
              onSelected={onDesignerSelected}
              linkTarget={linkTarget === "_blank" ? "_blank" : undefined}
              isBlackTheme={isDefaultCoverVisible}
              //@ts-ignore
              projectType={project?.projectType || projectType}
            />
          </Author>
          )
        }
        likes={
          !isOnlines && !isCard && (
            <LikesBox isBlackTheme={isDefaultCoverVisible} likes={project?.quPersonCount ?? likes ?? 0} isLiked={isLiked} isInteractive onClick={() => history.push(CreateLinkTo.projectNew(project))}/>
          )
        }
        point={
    // @ts-ignore
          ((showFirstCompetitionPoint || showCompetitionPoint) && !isOnlines) && <PointBox points={competitionGPA} textVisible={pointVisible} />
        }
        status={<AlertBlock />}
        deleteButton={
          <DeleteButton 
            onClick={() =>onRemoveFromBook && onRemoveFromBook(props?.project?.projectId ?? '')} 
          />
        }
        isRemovableFromBook={isRemovableFromBook}
        isCert={isCert}
        card={card}
        isBookChapter={isBookChapter}
      />
    );
  }
;

export default memo(ProjectCardNew);
import { FC, memo, useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox, useBreakpoint, useToasts } from '@brg/ui';
import { useProfile, bProfile } from '@brg/auth';
import { BookmarkAPI, Project, ProjectAPI, API, Endpoints, Card, Team, TeamAPI, Competition } from '@brg/api';
import { LayoutConst } from 'core/modules';

import { ProjectDesignerName } from '../projectDesignerName';
import { LikesBox } from '../likesBox';
import {ProjectCardSubTitle, ProjectCardTitle} from './styles';
import { ProjectCardTools } from './ProjectCardTools';
import { createCopyLinkProjectFn } from '../../helpers/copyLink';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import ProjectCardLayoutNew from './projectCardLayoutNew';
import { ProjectDelegate } from "../../../project-delegate";
import { useModal } from '../../../core'
import { IProjectLight } from "../../common";
import { ProjectEvents } from "../../helpers/projectEvents";
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { getProjectImages } from "../../pages/project/sections/ps-image";
import { useTranslation } from "react-i18next";
import { isProjectRepostedOnShowcase, isRejectedFromCompetition, ProjectOnDisplay } from "../../helpers/projectStatus";
import { SOUND_ART_TAG_ID } from "../../constants/misc";
import { AppTester } from 'supporting';
import { PointBox } from '../pointBox/PointBox';
import { AlertBlock } from 'shared/icons/AlertBlock';
import CheckSmallIcon from 'shared/icons/CheckSmallIcon';
import { DeleteButton } from '../DeleteButton/DeleteButton';
import { BookmarkButton } from '../bookmarkButtonOnProject/BookmarkButton';
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/constants';
import { useGetShowcaseContext } from 'shared/hooks/useGetShowcaseContext';
import { RingPositions } from 'shared/constants/ringPositionType';
import {BookDelegate} from "../../../_deziiign/books/core/book-delegate";
import {getPresentationImages} from "../../helpers/utils/getPresentationImages";
import { isTeamTabProjectWideCover } from 'shared/modals/teamTabProjectsOrder/teamTabProjectCoverLayout';
import { isExpert, isExpertByPolicy } from 'shared/helpers/utils/TagsUtils';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { ProfileRole } from 'core/utils/bProfile';
import { extractIds } from 'shared/constants/extractIds';
import { useFoldersController } from 'shared/hooks/useFoldersController';
import { useDispatch, useSelector } from 'react-redux';
import ProfileFoldersSlice, { ProfileFoldersSelector } from 'shared/reducers/ProfileFoldersSlice';
import urlApi from 'shared/actions/urlApi';
import { executeTypografValue } from 'shared/utils/executeTypograf';
import { Placement } from '../tooltips';
import RepostButton from '../repostButton/repostButton';
import { HiddenContentText } from './components/HiddenContentText';
import { useProjectCardPermissions } from './hooks/useProjectCardPermissions';
import { useDeleteLMSModule } from 'shared/hooks/api/LMS/useDeleteLMSModule';
import { DesignerTab } from 'shared/constants/designerTab';
import { useProjectCardCompetition } from './hooks/useProjectCardCompetition';
import { useProjectCardBookmark } from './hooks/useProjectCardBookmark';
import { ProjectBadge } from '../TeamBadges/ProjectBadge';

/** 
* Показать конкурсные баллы 
* @param showCompetitionPoint 
*/

export const ExportCheckbox = styled.div<{ checked?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 34px;
  border: 2px solid #fefefe;
  background: ${({ checked }) => checked ? 'rgba(254, 254, 254, 1)' : 'rgba(24, 26, 28, 0.5)'};
  backdrop-filter: blur(2px);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;

  &::after {
    content: '';
    display: ${({ checked }) => checked ? 'block' : 'none'};
    width: 7px;
    height: 12px;
    border: 2px solid #151514;
    border-top: none;
    border-left: none;
    transform: rotate(45deg) translate(-1px, -1px);
  }
`;

export const SelectRing = styled(FlexBox)<{ active?: boolean, ringPosition?: RingPositions, disable?: boolean, incIdx?: boolean }>`
  background: rgba(24, 26, 28, 0.5);
  border: 2px solid #fefefe;
  backdrop-filter: blur(2px);
  box-sizing: border-box;

  ${({ incIdx }) => incIdx && css`
    z-index: 1;
  `};
  border-radius: 34px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: white;

  ${({ disable }) => disable && css`
    pointer-events: none;
  `}

  ${({ ringPosition }) => ringPosition ? css`
    margin: ${ringPosition === RingPositions.left ? '0 auto 0 0' : '0 0 0 auto'};
  ` : null};

  svg {
    outline: none !important;
  }

  ${p => p.active ? css`
    background: rgba(254, 254, 254, 1);
    border: 2px rgba(254, 254, 254, 1);
    box-sizing: border-box;
    border-radius: 34px;
  ` : null}
`;

export const Author = styled(FInter.SmallText)<{ hasBottomText?: boolean }>`
  @media (max-width: 940px) {
    div {
      font-weight: 400;
    }
  }

  ${({ hasBottomText }) => !hasBottomText && css`
    color: ${Colors.geoWhite100};
  `}
`

export interface ProjectCardDisplayProps {
  isLoading?: boolean;
  isOneColumn?: boolean;
  width?: string;
  height?: string;
  sizeMult?: number;
  rank?: number;
  metaAlwaysVisible?: boolean;
  isMobileMoreVisible?: boolean;
  projectType?: string;
  itemType?: string;
}

export interface ProjectCardSelectionProps {
  isSelectable?: boolean;
  isUnselectable?: boolean;
  selected?: boolean;
  isSelectRightNeed?: boolean;
  selectRingPosition?: RingPositions;
  alreadyProject?: boolean;
  editingProject?: boolean;
  onSelect?: (projectId: string) => void;
  onSelectProject?: (project: Project | undefined) => void;
}

export interface ProjectCardCompetitionProps {
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  isParticipant?: boolean;
  competition?: Competition<'Local'>;
}

export interface ProjectCardPermissionProps {
  isEditable?: boolean;
  isDeletable?: boolean;
  isCanNotParticipate?: boolean;
  isCanNotBeDraft?: boolean;
  isCanNotBeBookmark?: boolean;
  canMakeImageForTeam?: TOwnerRights;
}

export interface ProjectCardNavigationProps {
  linkPrefix?: string;
  linkTo?: string;
  linkTarget?: string;
  withoutGoToProject?: boolean;
  openInModal?: boolean;
  useDirectNavigation?: boolean;
  isModal?: boolean;
  onProjectClick?: (projectId?: string, e?: any) => void;
}

export interface ProjectCardContentProps {
  project?: Project;
  isBook?: boolean;
  card?: Card;
  channel?: Team<'Global'>;
  isChannel?: boolean;
  entityType?: string;
  isRejected?: boolean;
  isRemovableFromBook?: boolean;
  isCert?: boolean;
}

export interface ProjectCardEventHandlers {
  onShouldReload?: (sender: any) => void;
  onRemoveFromBook?: (projectId: string) => void;
  onApprove?: (projectId: string) => void;
  onReject?: (projectId: string) => void;
  onUpdate?: () => void;
}

export interface ProjectCardNewProps extends 
  Partial<IProjectLight>, 
  ProjectEvents,
  ProjectCardDisplayProps,
  ProjectCardSelectionProps,
  ProjectCardCompetitionProps,
  ProjectCardPermissionProps,
  ProjectCardNavigationProps,
  ProjectCardContentProps,
  ProjectCardEventHandlers {
  tooltip?: ProjectTooltipProps;
  placement?: Placement;
  isCard?: boolean;
  withoutRepost?: boolean;
  dataKey?: any;
  showAnnotations?: boolean;
  isSortedByNotModerated?: boolean;
  isExport?: boolean;
  isMobile?: boolean;
  isOuterOrganizationShowcase?: boolean;
  isHeadCommentsVisibleLocal?: boolean;
  hideBelowCoverTitleAndAuthor?: boolean;
  activeTabKey?: string;
}

const ProjectCardNew: FC<ProjectCardNewProps> = (props) => {
    const {
      isLoading,
      isSelectable,
      isUnselectable,
      isDeletable,
      isOneColumn,
      isRemovableFromBook,
      image,
      identifier,
      // channel,
      isChannel,
      entityType,
      title,
      likes,
      authors,
      author,
      coAuthors,
      isLiked,
      isEditable,
      isRejected,
      tooltip,
      width,
      height,
      selected,
      rank,
      isParticipant,
      useDirectNavigation,
      metaAlwaysVisible,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      isMobileMoreVisible,
      currentCompetitionId,
      withoutRepost,
      openInModal,
      onApprove,
      onReject,
      onSelect,
      onShouldReload,
      onProjectClick,
      onRemoveFromBook,
      isModal,
      project,
      placement,
      isBook,
      alreadyProject,
      editingProject,
      linkPrefix,
      isSelectRightNeed,
      selectRingPosition,
      sizeMult,
      withoutGoToProject,
      isCanNotParticipate,
      canMakeImageForTeam,
      projectType,
      isCanNotBeDraft,
      isCanNotBeBookmark,
      isCard,
      itemType,
      onUpdate,
      onSelectProject,
      isCert,
      card,
      linkTo,
      linkTarget,
      competition,
      showAnnotations,
      isSortedByNotModerated,
      isExport,
      isMobile: isMobileProp,
      isHeadCommentsVisibleLocal,
      isOuterOrganizationShowcase,
      hideBelowCoverTitleAndAuthor,
      activeTabKey,
      ...handlers
    } = props;

    const history = useHistory();
    const profile = useProfile();
    const toasts = useToasts();
    const modal = useModal();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const isAgeyTomesh = AppTester.isAgeytomesh();
    const isOnlines = AppTester.isOnlines();
    const isMedia = AppTester.isMediiia();
    const isCompetitionProjectsPage = !!useRouteMatch('/competition/:id');
    const { id } = useParams<{ id: string }>();
    const [isReposted, setIsReposted] = useState<boolean>(false);
    const [pointVisible, setPoinVisible] = useState<boolean | null>(null);
    const [ showcaseContext ] = useGetShowcaseContext();
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);
    const isTab = useBreakpoint(LayoutConst.screen.m);

    const { foldersList } = useSelector(ProfileFoldersSelector);
    const { onRemoveProject } = useFoldersController();
    const { deleteModule: deleteLMSModule } = useDeleteLMSModule();

    const isLMSDraftsTab = activeTabKey === DesignerTab.lmsDrafts;

    const handleDeleteLMSModule = useCallback((projectId: string) => {
      modal.show('template-modal', {
        mainText: t('lms.delete_module.title'),
        secondText: t('lms.delete_module.description'),
        confirmText: t('lms.delete_module.confirm'),
        cancelText: t('lms.delete_module.cancel'),
        onConfirm: async () => {
          const ok = await deleteLMSModule(projectId);
          if (ok) {
            toasts.info(t('lms.delete_module.success'));
            onUpdate?.();
            onShouldReload?.(projectId);
            modal.hide();
          } else {
            toasts.error(t('lms.delete_module.error'));
          }
        },
        onSecond: () => modal.hide(),
      });
    }, [modal, t, toasts, deleteLMSModule, onUpdate, onShouldReload]);

    const isBanned = useMemo(() => project?.status === 3, [project])

    const isProjectFromCard = useMemo(() => {
      return project?.projectType === 'fixed-ratio-small' && project?.isAdaptiveCard
    }, [project])

    // @ts-ignore
    const hasBottomText = useMemo(() => {
      if (isProjectFromCard) {
        return false
      }
      return project?.projectType === 'fixed-ratio-large'
    }, [project]);

    const calcProjectType = useMemo(() => {
      //@ts-ignore
      const baseType = project?.projectType || projectType
      if (project && isOuterOrganizationShowcase && isTeamTabProjectWideCover(project)) {
        return 't-shape'
      }
      return baseType
    } , [project, projectType, isOuterOrganizationShowcase])

    const presentationImages = getPresentationImages(project);

    const handlePointViewToggle = (flag: boolean) => {
      setPoinVisible(flag)
    }

    const handleToolTipToggleMove = useCallback((val: boolean) => {
      setTooltipOpen?.(val);
    } , [])

    const onProjectClickDefault = useCallback((projectId?: string, ev?: any): void => {
      if (!projectId || !ev) {
        return;
      }

      // disable navigation for bookmark btn
      if (ev.target.tagName === "rect" || ev.target.tagName === "svg" || ev.target.tagName === "path" || (ev.target.tagName === "DIV" && ev.target.className.includes("BookmarkButtonWrapper"))) {
        ev.preventDefault()
      }

      if (openInModal) {
        modal.show('project', { projectId });
      }

    }, [modal, openInModal]);

    const onDesignerSelected = useCallback(
      (designerId: string): void => history.push(CreateLinkTo.designer(designerId)),
      [history]
    );

    const onRemoveFromShowcase = useCallback((projectId: string): void => {
      
      if (!showcaseContext || showcaseContext === '') {
        return;
      }

      if (Array.isArray(showcaseContext)) {
        Promise.all(showcaseContext?.map((i) => (
          API.request()
          .endpoint(Endpoints.geograffee)
          .url(`/api/Project/UpdateContexts`)
          .post()
          .body({
            projectId: projectId,
            contexts: [{
              context: i,
              operation: 0,
            }],
          })
          .send()
        )))
        .then(() => {
          onShouldReload?.(projectId);
          toasts.info(t('toasts.removed_from_showcase', { name: title }));
        });
        return;
      }

      API.request()
      .endpoint(Endpoints.geograffee)
      .url(`/api/Project/UpdateContexts`)
      .post()
      .body({
        projectId: projectId,
        contexts: [{
          context: showcaseContext,
          operation: 0,
        }],
      })
      .send()
      .then(() => {
        onShouldReload?.(projectId);
        toasts.info(t('toasts.removed_from_showcase', { name: title }));
      });
    }, [onShouldReload, title, toasts, t, showcaseContext]);

    const isBookChapter = window.location.pathname.startsWith("/books/book-edit") || (AppTester.isBooksMain() && window.location.pathname.startsWith("/book-edit"));

    const {
      isEditableLocal,
      canBeDraft,
      isMe,
      isCreator,
      canEditFolders,
      isTagModer_Expert,
      isTagModer_ExpertByPolicy,
      hasEditProjectPolicy,
      isMoreVisible: isMoreVisibleFromPermissions,
      canAddBookmark,
      isCanBeRepost,
      isHeadCommentVisible,
    } = useProjectCardPermissions({
      project,
      isEditable,
      isSelectable,
      isCanNotParticipate,
      isCanNotBeDraft,
      isBookChapter,
      isJury: showCompetitionJuryPoint
    });

    const titleImages = useMemo(() => {
      if (getProjectImages(project, i18n.language)?.length > 0) {
        return getProjectImages(project, i18n.language)
      }
      return presentationImages
    } , [project, presentationImages, i18n])
    
    const isProjectOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    const isProjectPartInCompetition = useMemo(() => {
      //@ts-ignore
      if (!project || project.canEdit_PartCompetition) return false;
      if (isRejectedFromCompetition(project, currentCompetitionId)) return false;
      return true;
    }, [project, currentCompetitionId])
    const isProjectTitle = useMemo(() => {
      if (Array.isArray(project?.additionalContent?.title?.text) && project?.additionalContent?.title?.text?.length === 0) {
        return undefined;
      }
      return executeTypografValue(project?.additionalContent?.title?.text)
    }, [project])
    const projectSubTitle = useMemo(() =>
    //@ts-ignore
    executeTypografValue(project?.additionalContent?.subtitle?.text), [project])

    const projectCardTitle = useMemo(() =>
      isProjectTitle || executeTypografValue(title), [isProjectTitle, title])

    const isDefaultCoverVisible = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN) && !project?.titleImages?.length), [project])

    const isSelectedClick = (sel: boolean | undefined) => {
      return sel ? undefined : CreateLinkTo.projectNew(project) 
    }

    const onRemoveFromFolders = async (projectId: string) => {
      if (!foldersList?.length) return;

      const initFolders = async () => {
        const data = await urlApi().fetchFolders(profile?.designerId ?? '')

        if (Array.isArray(data)) {
          dispatch(ProfileFoldersSlice.actions.setFolders(data))
        };
      }

      const tFolder = foldersList?.find((folder) => folder?.entityIds?.includes(projectId))

      if (tFolder) {
        onRemoveProject({...tFolder, entityIds: [projectId]}).then((r) => {
          initFolders();
        })
      }
    }

    const projectIsOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    //@ts-ignore
    const isPresentation = useMemo(() => (project?.isPresentation),[project]);

    const onDraft = useCallback((projectId: string): void => {
      if (isProjectPartInCompetition) {
        toasts.error(t('toasts.project_part_competition'))
        return
      }
      if (handlers?.onMoveDrafts) {
        handlers.onMoveDrafts(projectId)
        return
      }
      const confirmation = window.confirm(t('project.confirmation_msg.to_drafts'));
      if (!confirmation) return;
      ProjectAPI.UpdateStatus({ projectStatus: 0, projectId }).then(() => {
        onRemoveFromFolders(projectId)
        onShouldReload?.(projectId);
        toasts.info(t("toasts.project_move_to_drafts_title", {
          title
        }));
      });
    }, [toasts, onShouldReload, title, isProjectPartInCompetition, handlers, t]);
    
    const { competitionGPA } = useProjectCardCompetition({
      project,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      currentCompetitionId,
      competition,
    });

    const shouldVisibleRemoveFromShowcase = useMemo(() => (
      !AppTester.isDvaDesign() && 
      !AppTester.isGeoMain() &&
      !AppTester.isAcademy() &&
      !AppTester.isDeziiignMain() &&
      !AppTester.isMediiia()
      ), []
    )

    const hidePrivateProject = useMemo(() => {
      return isChannel && !isParticipant && project?.status === 10
    } ,[isChannel, isParticipant, project])

    const backgroundStyles = useMemo(() => {
      if (hidePrivateProject) {
        return {
          background: 'linear-gradient( 180deg,rgba(0, 0, 0, 0),  rgba(24, 26, 28, 0.3), rgba(24, 26, 28, 1) )',
          backdropFilter: 'blur(25px)',
          marginTop: 0
        }
      }
      return undefined
    } , [hidePrivateProject])

    const backgroundText = useMemo(() => {
      if (hidePrivateProject) {
        return <HiddenContentText />
      }
      return undefined
    } , [hidePrivateProject])

    const { isBookmarked, handleBookmarkClick } = useProjectCardBookmark({
      project,
      onUpdate,
    });

    useEffect(() => {
      if (!project) return;
      //@ts-ignore
      setIsReposted(project?.isReposted || false);
    }, [project]);

      const isMoreVisible = isExport ? true : isMoreVisibleFromPermissions;

      const isNominated = useMemo(() => {
        return !!project?.contexts?.includes('nomination')
      }, [project])

      const onNominationClick = useCallback(async () => {
        await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/UpdateContexts`)
        .post()
        .body({
          projectId: project?.projectId,
          contexts: [{
            context: 'nomination',
            operation: !isNominated? 1 : 0
          }],
        })
        .send()
        .then((res) => {
          if (res.status === 200) {
            const infoMsg = !isNominated? 'Проект номинирован на лучший проект месяца' : 'Проект снят с номинации'

            toasts.info(infoMsg);
          }
        }).catch((e) => {
          toasts.info('Ошибка запроса');
        })
      }, [isNominated, toasts, project])

      const tooltipProps = useMemo(() => {
        return {
          tooltipOpen: isTooltipOpen,
          toggleTooltip: handleToolTipToggleMove
        }
      } , [isTooltipOpen, handleToolTipToggleMove])

      const badge = useMemo(() => {
        if (!project) return undefined;
        return <ProjectBadge project={project} />
      } , [project])

      const selectRing = useMemo(() => {
        if (!isSortedByNotModerated) return undefined;
        return (
          <SelectRing className='selectRing' active={selected} ringPosition={RingPositions.left} onClick={(ev) => {
            if (onSelect) {
              ev.stopPropagation();
              ev.preventDefault();
              onSelect(identifier ?? '');
            }
            if (onSelectProject) {
              ev.stopPropagation();
              ev.preventDefault();
              onSelectProject(project);
            }
          }}>
            {selected && (
              <div>
                <CheckSmallIcon />
              </div>
            )}
          </SelectRing>
        );
      }, [identifier, isSortedByNotModerated, onSelect, onSelectProject, project, selected]);

      if (hidePrivateProject) {
        return (
          <ProjectCardLayoutNew
            isMobile={isMobileProp}
            title={''}
            linkTo={''}
            author={undefined}
            onClick={() => null}
            backgroundStyles={backgroundStyles}
            backgroundText={backgroundText}
            isMobileMoreVisible
            img={image}
            project={project}
            titleImages={titleImages}
            width={width}
            height={height}
            identifier={identifier}
            sizeMult={sizeMult}
            withoutGoToProject={true}
            itemType={itemType}
            projectType={calcProjectType}
          />
        )
      }

      
      return (
      <ProjectCardLayoutNew
        isMobile={isMobileProp}
        linkParams={showCompetitionJuryPoint && currentCompetitionId ? `?currentCompetitionId=${currentCompetitionId}` : ''}
        identifier={identifier}
        onClick={onProjectClick ?? onProjectClickDefault}
        img={image}
        badge={badge}
        backgroundStyles={backgroundStyles}
        project={project}
        titleImages={titleImages}
        isLoading={isLoading}
        width={width}
        linkTo={linkTo}
        linkTarget={linkTarget}
        height={height}
        isBook={isBook}
        rank={rank}
        isModal={isModal}
        href={isSelectedClick(selected)}
        hasBottomText={hasBottomText}
        title={<ProjectCardTitle>{projectCardTitle}</ProjectCardTitle>}
        subtitle={projectSubTitle ? <ProjectCardSubTitle>{projectSubTitle}</ProjectCardSubTitle> : undefined}
        isOneColumn={isOneColumn}
        isMoreVisible={isMoreVisible}
        isMobileMoreVisible={isMobileMoreVisible}
        isRejected={isRejected}
        isExport={isExport}
        metaAlwaysVisible={metaAlwaysVisible}
        {...tooltipProps}
        toggleViewPoint={handlePointViewToggle}
        linkPrefix={linkPrefix ? linkPrefix : undefined }
        isSelectRightNeed={isSelectRightNeed}
        sizeMult={sizeMult}
        withoutGoToProject={withoutGoToProject}
        itemType={itemType}
        projectType={calcProjectType}
        showAnnotations={showAnnotations}
        hideBelowCoverTitleAndAuthor={hideBelowCoverTitleAndAuthor}
        isSortedByNotModerated={isSortedByNotModerated}
        selectedComponent={selectRing}
        bookmarkButton={
          //@ts-ignore
          !isCompetitionProjectsPage && !isCard && !isBanned && (!isSelectable && <BookmarkButton type={project?.projectType === 't-shape'} isBookmarked={isBookmarked} onClick={handleBookmarkClick}/>)
        }
        repostButton={
          !isSelectable && !withoutRepost && !isBanned && project && profile && (
            <RepostButton 
              project={project} 
              iconOnPage 
              onUpdate={onShouldReload} 
            />
          )
        }
        more={
          isSortedByNotModerated ? null : (alreadyProject || editingProject) ? (
            <SelectRing active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} {...(isUnselectable && { onClick: (ev) => {
              if (onSelect) {
                ev.stopPropagation();
                ev.preventDefault();
                onSelect(identifier ?? '');
              }
            }})}>
                <div>
                  <CheckSmallIcon
                    fill={selected ? '#151514' : alreadyProject ? '#fff' : '#151514'}
                    stroke={selected ? '#151514' : alreadyProject ? '#fff' : '#151514'}
                  />
                </div>
            </SelectRing>
          ) : isSelectable
            ? (
              <SelectRing className='selectRing' active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} onClick={(ev) => {
                if (onSelect) {
                  ev.stopPropagation();
                  ev.preventDefault();
                  onSelect(identifier ?? '');
                }
                if (onSelectProject) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onSelectProject(project);
                }
              }}>
                {selected && (
                  <div>
                    <CheckSmallIcon />
                  </div>
                )}
              </SelectRing>
            )
            : isCard ? null : isExport ? (
              <ExportCheckbox
                checked={!!selected}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if (onSelect) onSelect(identifier ?? '');
                }}
              />
            ) : (
              <ProjectCardTools
                {...handlers}
                {...tooltipProps}
                placement={placement}
                isHiddenCancel={true}
                canViewStatistic={isTagModer_Expert}
                headCommentVisible={isHeadCommentVisible || isHeadCommentsVisibleLocal}
                isCanBeDraft={!isLMSDraftsTab && canBeDraft && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                identifier={identifier}
                isEditable={!isAgeyTomesh && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                isRemovableFromShowcase={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile) || hasEditProjectPolicy) && isProjectOnDisplay && shouldVisibleRemoveFromShowcase}
                isDeletable={isDeletable}
                {...(isLMSDraftsTab && { isDeletable: true, onDelete: handleDeleteLMSModule })}
                canEditFolders={canEditFolders}
                isCopyLink={true}
                projectType={calcProjectType}
                isInOnDisplay={isProjectOnDisplay}
                isSuperModer={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))}
                //@ts-ignore
                isTagModerator={profile && (profile.tagListId?.some(x => project?.tagsID?.includes(x)) || profile.tagListId_Expert?.some(x => project?.tagsID?.includes(x)))}
                isTagExpert={isTagModer_Expert || isTagModer_ExpertByPolicy}
                isNominated={isNominated}
                onNominationClick={onNominationClick}
                isTeamOwner={canMakeImageForTeam?.canMake}
                onMoveFromShowcase={onRemoveFromShowcase}
                onCopyLink={createCopyLinkProjectFn(toasts, t)}
                onMoveDrafts={onDraft}
                isPresentation={isPresentation}
                toggleTooltip={handleToolTipToggleMove}
                isCoauthor={profile && project?.coAuthorIds?.includes(profile?.accountId)}
                onAddBookmark={handleBookmarkClick}
                onOpenHeadComment={() => {
                  modal.show('head-comment', {
                    project: project,
                    competitionId: currentCompetitionId,
                  })
                }}
                onRejectCoauthor={() => {
                  const confirmation = window.confirm('Вы действительно хотите отказаться от соавторства?');
                  if (confirmation) {
                    API.request()
                        .endpoint(Endpoints.geograffee)
                        .url('/api/Project/RefuseCoAuthorship')
                        .post()
                        .body({
                            projectId: project?.projectId || ''
                        })
                        .release()
                        .then((r: any) => {
                            if (r.status === 400 || r.status === 500) {
                                toasts.error(t('toasts.project_reject_coauthor_error'))
                                return;
                            }
                            toasts.info(t('toasts.project_reject_coauthor'))

                            setTimeout(() => window.location.reload(), 1500)
                        })
                        .catch((e: any) => toasts.error(t('toasts.project_reject_coauthor_error')))
                      }
                }}
                onMakeImageForOrganization={(projectId) => {
                  if (canMakeImageForTeam?.canMake) {
                    const confirmation = window.confirm('Сделать изображение обложкой юнита?');
                    if (confirmation) {
                      API.request()
                      .endpoint(Endpoints.geograffee)
                      .url('/api/Team/CopyTitleFromProject')
                      .post()
                      .body({
                        teamId: canMakeImageForTeam.teamId,
                        projectId
                      })
                      .release()
                      .then((r: Response) => {
                        toasts.info('Успешно');
                      })
                      window.location.reload();
                    }
                  }
                 }} 
                onMakeBilingual={(projectId) => {
                  const confirmation = window.confirm('Вы действительно хотите сделать проект двуязычным?')
                  if (confirmation) {
                    history.push(CreateLinkTo.bilingual(projectId))
                  }
                }}
                onRepost={() => {
                  modal.show('repost-into-channel', {
                    projectId: project?.projectId,
                    // callBack: (flag: boolean) => {
                    //   setIsReposted(flag)
                    // }
                  })
                }}
                  //@ts-ignore
                canMakeBilingual={!project?.isBilingual && !project?.longreadId_en
                && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
                && !(projectIsOnDisplay && !(profile && bProfile.isModer(profile)) && !hasEditProjectPolicy)
                &&  !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                {...(tooltip ?? {})}
                project={project}
                linkPrefix={linkPrefix ? linkPrefix : undefined }
                isCanNotParticipate={isCanNotParticipate}
                isPartInCompetition={isProjectPartInCompetition}
                isBookmarked={isBookmarked}
                canAddBookmark={canAddBookmark}
                isCanBeRepost={isCanBeRepost}
              />
            )
        }
        author={
          !isOnlines && (
            <Author hasBottomText={hasBottomText} >
            <ProjectDesignerName
              value={author ? [author].concat(coAuthors ?? []) : (coAuthors ?? [])}
              onSelected={onDesignerSelected}
              linkTarget={linkTarget === "_blank" ? "_blank" : undefined}
              isBlackTheme={isDefaultCoverVisible}
              //@ts-ignore
              projectType={project?.projectType || projectType}
            />
          </Author>
          )
        }
        likes={
          !isOnlines && !isCard && (
            <LikesBox isBlackTheme={isDefaultCoverVisible} likes={project?.quPersonCount ?? likes ?? 0} isLiked={isLiked} isInteractive onClick={() => history.push(CreateLinkTo.projectNew(project))}/>
          )
        }
        point={
    // @ts-ignore
          ((showFirstCompetitionPoint || showCompetitionPoint) && !isOnlines) && <PointBox points={competitionGPA} textVisible={pointVisible} />
        }
        status={<AlertBlock />}
        deleteButton={
          <DeleteButton 
            onClick={() =>onRemoveFromBook && onRemoveFromBook(props?.project?.projectId ?? '')} 
          />
        }
        isRemovableFromBook={isRemovableFromBook}
        isCert={isCert}
        card={card}
        isBookChapter={isBookChapter}
      />
    );
  }
;

export default memo(ProjectCardNew);
